// removed by extract-text-webpack-plugin
module.exports = {"ap-ui__spacer":"_1GTz6-ap-ui__spacer","ap-ui__spacer--default":"_1-Dn9-ap-ui__spacer--default","ap-ui__spacer--thin":"_38yed-ap-ui__spacer--thin","ap-ui__spacer--thick":"aJYRp-ap-ui__spacer--thick","ap-ui__spacer--thicker":"ey6M8-ap-ui__spacer--thicker"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/Spacer/Spacer.scss
// module id = 802
// module chunks = 0